<template>
  <div class="things-box d-flex">
    <div :class="['df-group', {active:!location}]">
      <location-input :value="location" :extra="locationExtra" ref="location"
        :error="validation.location" leg="leg1" :disabled="sightSeeing.location.loading"
        @change="locationNewValue" @submit="triggerClickSubmit"
      ></location-input>
    </div>
    <div class="df-group">
      <input type="text" v-model="dateLoc" @click="showDate" class="txt-field" readonly />
    </div>
    <a @click="submit($event)" ref="quoteBtn" class="lr-btn">Search</a>

    <date-modal :startDate="sightSeeing.date.start" :endDate="sightSeeing.date.end" @newDate="newDate" />
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import LocationInput from '../LocationInput'
import DateModal from './DateTimePicker'

export default {
  name: 'sight-seeing-form',
  components: { LocationInput, DateModal },
  data () {
    return {
      location: '',
      locationExtra: {
        field: 'sight-seeing',
        placeholder: 'Going to',
        type: 'location'
      },
      dateLoc: '',
      validation: {
        location: ''
      }
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    filters () { return this.booking.filters },
    user () { return this.$store.state.user },
    sightSeeing () { return this.$store.state.sightSeeing },
    locations () { return this.sightSeeing.location }
  },
  methods: {
    locationNewValue (x) {
      if (x.keyInput && x.check) {
        this.validation.location = ''
        this.location = x.keyInput
        this.showDate()
      }
    },
    triggerClickSubmit () {
      this.submit()
    },
    showDate () {
      this.$store.commit('sightSeeing/setDateData', {show: true})
    },
    newDate (x) {
      this.$store.commit('sightSeeing/setDateData', x)
      this.updateDate()
      this.submit()
    },
    updateDate () {
      // this.dateLoc = `${this.things.date.start} - ${this.things.date.end}`
      this.dateLoc = this.sightSeeing.date.start
    },
    submit () {
      let self = this
      self.validation.location = ''
      if (!self.location) {
        self.validation.location = 'This field cannot be empty.'
        return
      }
      self.$store.commit('global/setLoaderData', {show: true})
      let startDate = moment(self.sightSeeing.date.start, 'MM/DD/YYYY').format('YYYY-MM-DD')
      // let endDate = moment(self.things.date.end, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let endDate = ''
      if (startDate === endDate) endDate = ''
      self.$sdk.post2(`${CONFIG.d2dAPI}/sightseeing/provider1/search`, {
        city_id: self.locations.selected.origin,
        start_date: startDate,
        end_date: endDate,
        cat_id: 0,
        sub_cat_id: 0,
        sort_order: 'TOP_SELLERS',
        text: ''
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status || r.error) {
          let msg = r.Message
          if (r.error.message) msg = r.error.message
          self.$store.commit('global/setAlertData', {
            show: true,
            message: msg
          })
          return
        }

        // self.setupPax()

        let categories = []
        r.Search.SSSearchResult.SightSeeingResults.forEach(x => {
          categories = [...new Set([...categories, ...Object.values(x.Cat_Ids)])]
        })
        self.$store.commit('sightSeeing/setData', {
          list: r.Search.SSSearchResult.SightSeeingResults,
          categories: categories
        })
        self.$store.commit('sightSeeing/setFilterData', {categories: JSON.parse(JSON.stringify(categories))})
        self.$store.commit('reservation/setOtherData', {bookingType: 'sightSeeing'})
        self.$router.push('sight-seeing')
      })
    },
    setupPax () {
      let paxForm = { adult: [], children: [], infants: [] }
      let paxFields = {
        title: '',
        gender: '',
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        mobile: '',
        email: '',
        bday: '',
        birthDay: '',
        birthMonth: '',
        birthYear: '',
        passport: '',
        address: '',
        city: '',
        zip: '',
        country: '',
        countryCode: ''
      }
      let defaultAdded = false
      for (let x = 0; x < this.filters.travellers.adult; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        if (this.user.token && x === 0 && !defaultAdded) {
          if (this.user.title) tmpObj.title0 = this.user.title
          if (this.user.gender) {
            tmpObj.gender0 = this.user.gender
            if (this.user.gender === 'Male') tmpObj.gender0 = 1
            if (this.user.gender === 'Female') tmpObj.gender0 = 2
          }
          tmpObj.firstName0 = this.user.firstName
          tmpObj.lastName0 = this.user.lastName
          tmpObj.email0 = this.user.email
          tmpObj.mobile0 = this.user.phone.number
          tmpObj.countryCode0 = this.user.phone.code
          if (this.user.bday) {
            let dob = moment(this.user.bday, 'YYYY-MM-DD')
            tmpObj.birthDay0 = dob.format('DD')
            tmpObj.birthMonth0 = dob.format('MM')
            tmpObj.birthYear0 = dob.format('YYYY')
          }
          if (this.user.address) tmpObj.address0 = this.user.address
          if (this.user.city) tmpObj.city0 = this.user.city
          if (this.user.zip) tmpObj.zip0 = this.user.zip
          if (this.user.country) tmpObj.country0 = this.user.country
          if (this.user.passportNum) tmpObj.passport0 = this.user.passportNum
          defaultAdded = true
        }
        paxForm.adult.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.children; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.children.push(tmpObj)
      }
      for (let x = 0; x < this.filters.travellers.infants; x++) {
        let tmpObj = {}
        Object.keys(paxFields).forEach(f => {
          tmpObj[`${f}${x}`] = paxFields[f]
        })
        paxForm.infants.push(tmpObj)
      }
      this.$store.commit('booking/clearTravellerInfo')
      this.$store.commit('booking/addTravellerInfo', paxForm)
    }
  },
  mounted () {
    if (this.sightSeeing.location.selected && this.sightSeeing.location.selected.destinationName) this.location = `${this.sightSeeing.location.selected.destinationName}, ${this.sightSeeing.location.selected.countryName}`
    if (!this.sightSeeing.date.start) {
      this.$store.commit('sightSeeing/setDateData', {
        start: moment().add(3, 'days').format('MM/DD/YYYY'),
        end: ''
        // end: moment().add(3, 'days').format('MM/DD/YYYY')
      })
      this.updateDate()
    } else {
      this.dateLoc = this.sightSeeing.date.start
    }
  }
}
</script>

<style lang="scss" scoped>
.things-box{
  gap: 10px;
  padding: 10px;
}
.df-group{
  width: 100%;
  &.active{
    outline: 2px solid #ff9c09;
  }
}
.txt-field{
  margin: 0;
  color: #333;
  width: 100%;
  position: relative;
  z-index: 1;
  box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
  outline: none;
  background: #fbfbfb;
  border: 1px solid #ccc;
  height: 40.4px;
  border-radius: 0;
  padding: 10px;
}

@media only screen and (max-width: 641px) {
  .things-box{
    flex-direction: column;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?0a3ef89d